const SEO = [
	{
		page: "home",
		description:
			"I am a backend developer with expertise in Python and C++. I have experience in building scalable, secure and reliable web applications and apis using various frameworks and technologies.",
		keywords: ["Joseph", "Joseph D", "Joseph Dinsmoor"],
	},

	{
		page: "about",
		description:
			"I am a backend developer with expertise in Python and C++. I have experience in building scalable, secure and reliable web applications and apis using various frameworks and technologies. In my spare time, I play guitar in a Deathcore band called Ill Doctrine. I also build tube guitar amplifiers for guitar players across the east coast.",
		keywords: ["Joseph", "Joseph D", "Joseph Dinsmoor"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Joseph", "Joseph D", "Joseph Dinsmoor"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Joseph", "Joseph D", "Joseph Dinsmoor"],
	},
];

export default SEO;
